<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Заказы печати
      <span v-if="total">({{ total }})</span>
    </h1>

    <resource-list
      url="/print-orders"
      current-sort="datetime"
      resource-name="print_orders"
      :show-per-page="false"
      :fields="fields"
      :filters="filters"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'print-orders',
  components: { resourceList },
  data () {
    return {
      total: null,
      fields: [
        { name: 'block_name', label: 'Подьезд', sort: false },
        { name: 'from_date', label: 'Нач. дата', sort: true },
        { name: 'to_date', label: 'Кон. дата', sort: true },
        { name: 'months', label: 'Кол-во месяцев', sort: true },
        { name: 'from_date2', label: 'Нач. дата 2', sort: true },
        { name: 'to_date2', label: 'Кон. дата 2', sort: true },
        { name: 'months2', label: 'Кол-во месяцев 2', sort: true },
        { name: 'datetime', label: 'Дата создания', sort: true, datetime: true },
        { name: 'bill_file_url', label: 'Файл квитанции', sort: false, url: true }
      ],
      actionRoutes: [
        { name: 'delete-print-order', returnId: true, label: 'Удалить заказ' }
      ]
    }
  },
  methods: {
    updateTotal (val) {
      this.total = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// PrintOrders.vue?44cf9523